import { render, staticRenderFns } from "./settings-column.vue?vue&type=template&id=71001ea4"
import script from "./settings-column.vue?vue&type=script&lang=js"
export * from "./settings-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports